import * as React from 'react';
import * as styles from './RoadsMap.css';
import { ITelemetryLogger } from '@cian/telemetry/shared';

interface IMapImageProps {
  src: string;
  telemetry: ITelemetryLogger;
}

export const MapImage: React.FC<IMapImageProps> = ({ src, telemetry }) => {
  React.useEffect(() => {
    telemetry.increment('static-maps.request');
  }, [telemetry]);

  const handleError = React.useCallback(() => {
    telemetry.increment('static-maps.error');
  }, [telemetry]);

  return <img className={styles['map']} src={src} onError={handleError} />;
};
